// extracted by mini-css-extract-plugin
export default {"menuContainer":"menuContainer__xbLZK","expandContainer":"expandContainer__JzVL0","caret":"caret__W9tVn","button":"button___KeKe"};